import React from 'react';
import { useTranslation } from 'react-i18next';

import ChoiceCard from 'components/Auth/Register/ChoiceCard/ChoiceCard';
import style from 'components/Auth/Register/RoleChoice/RoleChoice.module.scss';
import WelcomeRespondent from 'components/common/icons/redesign/WelcomeRespondent';
import WelcomeModerator from 'components/common/icons/redesign/WelcomeModerator';
import WelcomeTranslator from 'components/common/icons/redesign/WelcomeTranslator';

import UserRoles from 'constants/UserRoles';
import BottomMessage from 'components/Page/BottomMessage/BottomMessage';
import Routes from 'constants/Routes';
// import Button, { ButtonStyles } from 'components/common/Form/Button';

export default function RoleChoice({ onClick }) {
    const { t } = useTranslation();

    return (
        <>
            <div className={style.roleCardsWrapper}>
                <ChoiceCard
                    title={t('roles.respondent')}
                    text={t('roles.brief.respondent')}
                    role={UserRoles.respondent}
                    onClick={onClick}
                    icon={<WelcomeRespondent />}
                />
                <ChoiceCard
                    title={t('roles.moderator')}
                    text={t('roles.brief.moderator')}
                    role={UserRoles.moderator}
                    onClick={onClick}
                    icon={<WelcomeModerator />}
                />
                <ChoiceCard
                    title={t('roles.linguist')}
                    text={t('roles.brief.translator')}
                    role={UserRoles.translator}
                    onClick={onClick}
                    icon={<WelcomeTranslator />}
                />
            </div>
            <div className={style.clientMessage}>
                {/*TODO: VOV-4132 uncomment when client ask for it }
                {/* <div className={style.message}>{t('auth:text.wantToConduct')}</div>
                <Button
                    text={t('auth:text.asClient')}
                    href={`${Routes.signUp.path}/${UserRoles.companyAdminAuth}`}
                    className={style.buttons}
                    btnStyle={ButtonStyles.secondary}
                /> */}
                <BottomMessage
                    text={`${t('pages.auth.alreadyRegistered')}`}
                    linkText={`${t('pages.auth.signIn')}`}
                    linkTo={Routes.signIn.path}
                    className={style.bottom}
                />
            </div>
        </>
    );
}
